import * as types from './actionTypes';

const initialState = {
  approvals: [],
  timesheetEmployeeApprovals: [],
  hrApprovals: [],
  generatehrApprovals: [],
  finalApprovals: [],
  loading: false,
  error: null,
  success: false,
};

const timesheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TIMESHEET_APPROVALS_REQUEST:
    case types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_REQUEST:
    case types.UPDATE_TIMESHEET_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_APPROVALS_SUCCESS:
      return { ...state, loading: false, approvals: action.payload, success: false };

    case types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_SUCCESS:
      return { ...state, loading: false, timesheetEmployeeApprovals: action.payload, success: false };

    case types.UPDATE_TIMESHEET_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_TIMESHEET_APPROVALS_FAILURE:
    case types.FETCH_TIMESHEET_EMPLOYEE_DETAILS_FAILURE:
    case types.UPDATE_TIMESHEET_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    case "RESET_TIMESHEET_EMPLOYEE_APPROVALS":
      return {
        ...state,
        approvals: [],
        success: false
      };

    case types.FETCH_TIMESHEET_HR_APPROVAL_REQUEST:
    case types.GENERATE_TIMESHEET_HR_APPROVAL_REQUEST:
    case types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_HR_APPROVAL_SUCCESS:
      return { ...state, loading: false, hrApprovals: action.payload, success: false };

    case types.GENERATE_TIMESHEET_HR_APPROVAL_SUCCESS:
      return { ...state, loading: false, generatehrApprovals: action.payload, success: false };

    case types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_TIMESHEET_HR_APPROVAL_FAILURE:
    case types.GENERATE_TIMESHEET_HR_APPROVAL_FAILURE:
    case types.SAVE_GENERATED_TIMESHEET_HR_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.RESET_TIMESHEET_HR_APPROVALS:
      return { ...state, hrApprovals: [],generatehrApprovals: [] };

    case types.FETCH_TIMESHEET_FINAL_APPROVAL_REQUEST:
    case types.SAVE_TIMESHEET_FINAL_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_FINAL_APPROVAL_SUCCESS:
      return { ...state, loading: false, finalApprovals: action.payload, success: false };

    case types.SAVE_TIMESHEET_FINAL_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_TIMESHEET_FINAL_APPROVAL_FAILURE:
    case types.SAVE_TIMESHEET_FINAL_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.RESET_TIMESHEET_FINAL_APPROVAL:
      return { ...state, finalApprovals: [], success: false, error: null };

    default:
      return state;
  }
};

export default timesheetReducer;
